import React from "react";
/* eslint-disable */
import {
    Box,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';
import moment from "moment";


export default class ComponentToPrint extends React.Component {

    render() {
        const grnData = this.props.grnList;
        const searchQueryData = this.props.searchData;
        const totalValues = this.props.totalValues;
        const toDate = this.props.toDate;
        const fromDate = this.props.fromDate;

        return (
            <div>
                <br />
                <br />
                <h3><center><u>Financial GRN Report</u></center></h3>
                <div>&nbsp;</div>
                {/* <h4><left>Group - {searchQueryData.groupName} </left></h4>
                <h4><left>Fresh Collection Center - {searchQueryData.operationEntityID}</left></h4>
                <h4><left>Farmer - {searchQueryData.farmerID}</left></h4>
                <h4><left>{moment(fromDate).format("YYYY-MM-DD")} - {moment(toDate).format("YYYY-MM-DD")}</left></h4> */}
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer style={{ marginLeft: '5px' }}>
                        <Table aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align={'left'}>FCC Code </TableCell>
                                    <TableCell align={'left'}>FCC Name </TableCell>
                                    <TableCell align={'left'}>GRN Date </TableCell>
                                    <TableCell align={'left'}>Supplier Code - Agrithmics </TableCell>
                                    <TableCell align={'left'}>Supplier Name </TableCell>
                                    <TableCell align={'left'}>Invoice No </TableCell>
                                    <TableCell align="left">GRN Type</TableCell>
                                    <TableCell align={'right'}>Purchase Value </TableCell>
                                    <TableCell align={'right'}>Deduction</TableCell>
                                    <TableCell align={'right'}>Net Puchase Value  </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {grnData.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.fccCode == null ? '-' : data.fccCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.fccName == null ? '-' : data.fccName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {new Date(data.grnDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.supplierCode == null ? '-' : data.supplierCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.supplierName == null ? '-' : data.supplierName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.invoiceNo == null ? '-' : data.invoiceNo}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.invoiceNo == null ? '-' : data.grnType ==4 ? "Credit" : "Cash"}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.purchaceValue == null ? '-' : parseFloat(data.purchaceValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {(data.deduction == null) || (data.deduction == 0) ? '-' : parseFloat(data.deduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.netPurchaseValue == null ? '-' : parseFloat(data.netPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableRow>
                            <TableCell align="center" colSpan={7} style={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalPurchaceValue == null ? '-' : parseFloat(totalValues.totalPurchaceValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{(totalValues.totalDeduction == null) || (totalValues.totalDeduction == 0) ? '-' : parseFloat(totalValues.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalNetPurchaseValue == null ? '-' : parseFloat(totalValues.totalNetPurchaseValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>   
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
